<template>
    <div class="wrapper">
        <v-head></v-head>
        <v-sidebar></v-sidebar>
        <div class="content-box">
            <div class="content">
                <transition name="move" mode="out-in"><router-view></router-view></transition>
            </div>
        </div>
    </div>
</template>

<script>
import vHead from '@/components/Header.vue';
import vSidebar from '@/components/Sidebar.vue';
export default {
    components: {
        vHead,
        vSidebar
    },

    mounted() {
        if (this.$route.path != '/place-order') {
            // 去掉下单页面缓存信息
            sessionStorage.removeItem('flag');
            sessionStorage.removeItem('caseFlag');
            sessionStorage.removeItem('placeOrderId');
        }
    }
};
</script>

<style lang="scss" scoped>
.content-box {
    max-width: 1200px;
    position: absolute;
    right: 0;
    left: 240px;
    top: 92px;
    bottom: 0;
    padding-bottom: 30px;
    -webkit-transition: left 0.3s ease-in-out;
    transition: left 0.3s ease-in-out;
    background: #f8fbff;
    padding: 20px 55px 60px 55px;
    box-sizing: border-box;
    overflow-y: auto;
}
</style>
